/*
 * Industry pages served on tryapex25.com next to the home page. To add one (e.g. "/for-hospitality"):
 *   1. add it here and to APEX25_INDUSTRY_PAGES in apps/server/src/brand-sites/brand-sites.ts
 *      (brand-sites.spec.ts fails if they drift),
 *   2. register its component in APEX25_INDUSTRY_COMPONENTS in pages/apex25/industry-routes.tsx.
 * The server then serves it with its own <head>, lists it in sitemap.xml and stops redirecting it.
 * Keep this file free of React/JSX: the server spec imports it.
 */
/** Metadata for tryapex25.com "/". Mirrors APEX25_HOME_META on the server. */
export const APEX25_HOME_META = {
  title: "Apex 25 | Intelligence-first recruiting",
  description:
    "Screen resumes, run structured interviews, and rank candidates objectively — with humans in control of every call.",
};

export const APEX25_INDUSTRY_PAGES: Record<string, { title: string; description: string }> = {
  "/for-legal": {
    title: "Legal Recruitment | Spend less time screening CVs | Apex 25",
    description:
      "Support your legal HR team with CV ranking, AI first-round interviews, and candidate feedback. Gather more data for your next legal hire with Apex 25.",
  },
};

/**
 * The Apex 25 legal set, served from tryapex25.com (and at /apex25<path> on staging and
 * localhost). "/legal" is the hub that lists the others. Each document renders a markdown file in
 * pages/apex25/legal/docs. Mirrors APEX25_LEGAL_PAGES on the server (brand-sites.spec.ts fails if
 * they drift). To add a document: add its path here and on the server, its .md file, and an entry
 * in pages/apex25/legal/registry.ts.
 */
export const APEX25_LEGAL_PAGES: Record<string, { title: string; description: string }> = {
  "/legal": {
    title: "Apex 25 legal documents",
    description:
      "The terms, privacy policy and candidate interview terms that apply to Apex 25, our AI-assisted applicant tracking system.",
  },
  "/terms": {
    title: "Apex 25 Customer Terms of Service",
    description:
      "The terms that apply when a business signs up for Apex 25 and uses it to assess and interview applicants.",
  },
  "/privacy": {
    title: "Apex 25 Privacy Policy",
    description:
      "How Apex 25 collects, uses, stores and discloses personal information, including how AI is used in hiring.",
  },
  "/candidate-terms": {
    title: "Apex 25 Candidate Interview Terms",
    description:
      "The terms, consent and privacy collection notice for candidates invited to an AI interview through Apex 25.",
  },
  "/trial-terms": {
    title: "Apex 25 trial terms",
    description: "The terms for trying Apex 25's AI interview demo.",
  },
};
